import React, { PropsWithChildren } from 'react'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { ChatPageSidebar } from 'components/chat-page/ChatPageSidebar'
import { ModalOutlet } from 'providers/ModalProvider'
import { PortalToastContainer } from 'components/ui/PortalToastContainer'
import { CookieConsent } from 'components/cookie/CookieConsent'

export const ChatPageShell = ({ children }: PropsWithChildren) => (
  <SidebarProvider
    className="h-dvh min-h-0 overflow-hidden bg-background font-sans text-foreground"
    style={{ '--sidebar-width': '280px' } as React.CSSProperties}
  >
    <ChatPageSidebar />

    <SidebarInset className="min-w-0 bg-background">
      {children}
      <PortalToastContainer topOffset={16} />
    </SidebarInset>

    <CookieConsent surface="page" />
    <ModalOutlet variant="dialog" />
  </SidebarProvider>
)
